<template>
  <div>
    <div class="search-container">
      <input
        v-model="search"
        placeholder="Enter name"
        class="search"
        @keyup="searchInputKeyUp"
      >
    </div>
    <div class="dialogs-list">
      <div
        v-for="dialog in orderedDialogs"
        :key="dialog.id"
        class="planner-comm__person"
        :class="{ 'planner-comm__person_active': activeDialog === dialog._id }"
        @click="selectDialog(dialog)"
      >
        <div class="planner-comm__name">
          <v-avatar v-if="getAvatar(dialog)" size="30px" style="margin-right: 15px">
            <img :src="getAvatar(dialog).link">
          </v-avatar>
          <v-avatar v-else size="30px" style="margin-right: 15px" :color="colors[dialog.name[0]]">
            <span class="white--text">{{ dialog.name | initials }}</span>
          </v-avatar>
          <span>{{ dialog.name }}</span>
          <span
            v-if="dialog.unreadMessages && dialog.unreadMessages.length"
            class="planner-comm__unread"
          >{{ dialog.unreadMessages.length }}</span>
        </div>
        <v-divider />
      </div>
    </div>
  </div>
</template>

<script>
import avatarColors from '../../utils/avatarColors'
import { sortNames } from '../../utils/generalUtils'

export default {
  filters: {
    initials: function(value) {
      if (!value) return ''
      value = value.split(' ')
      let response = ''
      for (const v of value) {
        response = response + v.charAt(0).toUpperCase()
      }
      return response
    }
  },
  props: {
    dialogs: {
      type: Array,
      default: () => []
    },
    activeDialog: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      colors: avatarColors,
      sortMode: true,
      search: '',
      filteredDialogs: []
    }
  },
  computed: {
    orderedDialogs() {
      const data = this.search ? this.filterNames(this.dialogs) : this.dialogs
      return this.sortMode ? sortNames(data) : sortNames(data).reverse()
    }
  },
  methods: {
    selectDialog(dialog) {
      this.$emit('select-dialog', dialog)
    },
    clicked() {
      this.sortMode = !this.sortMode
    },
    filterNames(dialogsForFiltering) {
      let regex = new RegExp('^' + this.search + '.*', 'i')
      return dialogsForFiltering.filter(word => word.name.match(regex))
    },
    searchInputKeyUp() {
      this.orderdDialogs = this.orderedDialogs
    },
    getAvatar(dialog) {
      return dialog && dialog.media
        ? dialog.media.find(item => item.type === 'avatar') : undefined
    }
  }
}
</script>

<style lang="sass">
  .dialogs-list
    overflow-y: scroll
    height: calc(100vh - 110px)

  hr
    margin: 0
  .planner-comm
    &__wrap
      background-color: #fff
    &_content
      font-size: 14px
      padding: 2rem
      text-align: left
      border-radius: 1rem
    &__person
      &_active
        background: #E1E1E1
      &:hover
        background: #E1E1E1
    &__name
      padding: 10px
      display: flex
      align-items: center
    &__unread
      border-radius: 50%
      width: 26px
      height: 26px
      color: white
      text-align: center
      margin-left: auto
      background: $hwayzNavigationTab
      padding-top: 2px
  .sortArrow.up
    transform: rotate(180deg)

  .search-container
    display: flex
    flex-direction: row
    align-items: flex-end
    padding: 10px 0
  .search
    width: 100%
    height: 40px
    padding: 10px 1rem
    border: 1px solid #ececec
</style>
